import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class FormulationService {

  private messageSource = new BehaviorSubject({});
  currentEditFormulation = this.messageSource.asObservable();

  constructor(public apiService: ApiService) { }

  changeEditFormulation(data: any) {
    this.messageSource.next(data)
  }

  getAllFormulationStock(body : any): Observable<any> {
    return this.apiService.post('formulations/getAllProductsStock', body)
  }

  getAllFormulations(body : any): Observable<any> {
    return this.apiService.post('formulations/getFormulas', body)
  }

  getAllFormulationsByCompanyId(body : any): Observable<any> {
    return this.apiService.post('formulations/getFormulasByCompanyId', body)
  }

  addFormulation(body : any): Observable<any> {
    return this.apiService.post('formulations/createFormulas', body);
  }

  editFormulation(body: any, param: any): Observable<any> {
    return this.apiService.put('formulations/editFormula', param, body);
  }
  beforeNewCreation(body :  any): Observable<any> {
    return this.apiService.post('formulations/beforeNewCreation',body);
  }
  inActive(body :  any, param : any): Observable<any> {
    return this.apiService.put('formulations/inactivateFormula', param, body);
  }
  active(body :  any, param : any): Observable<any> {
    return this.apiService.put('formulations/activateFormula', param, body);
  }
  getFormulaById(body :  any): Observable<any> {
    return this.apiService.post('formulations/getFormulaById',body);
  }
  getActiveFormulation(body :  any): Observable<any> {
    return this.apiService.post('formulations/getActiveFormula',body);
  }
  getMlcsByFormulaId(body :  any): Observable<any> {
    return this.apiService.post('formulations/getMLCsByFormulaID',body);
  }
  getImportProduct(body :  any): Observable<any> {
    return this.apiService.post('formulations/importFormulations',body);
  }
  getParentFormulas(body :  any): Observable<any> {
    return this.apiService.post('formulations/getParentFormulas',body);
  }
  getSubEditFormula(body: any): Observable<any> {
    return this.apiService.post('formulations/subEditFormula', body);
  }
}
